module.exports = __webpack_public_path__ + "assets/img/help.ac2c94a4.svg";